import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const MapFlyTo = ({ center, zoom, isFlyToEnabled }) => {
    const map = useMap();

    useEffect(() => {
        if (isFlyToEnabled && center) {
            map.flyTo(center, zoom, {
                duration: 0.7,
                easeLinearity: 0.7
            });
        }
    }, [center, isFlyToEnabled, map]);

    return null;
};

export default MapFlyTo;